import {
    AdminRoleInternal,
} from '@michel.freiha/ng-sdk';


export class Select {
    public static readonly type: string = '[Roles] Select to comparison';
    constructor(public payload: { roles: AdminRoleInternal[] }) { }
}
